type PlaywrightData = {
  tenantSlug?: string;
  jwt?: string;
};

declare global {
  interface Window {
    __playwrightData__?: PlaywrightData;
  }
}

export default function getPlaywrightData(): PlaywrightData | null {
  if (window.__playwrightData__) {
    return window.__playwrightData__;
  }

  if (navigator.userAgent.includes("STW-Playwright")) {
    // Safari doesn't support subdomains of localhost (https://github.com/microsoft/playwright/discussions/15890)
    // so we use a user agent string to pass the tenant ID to the browser.
    const match = navigator.userAgent.match(/STW-Playwright\/(.*)/);
    if (match) {
      return JSON.parse(match[1]);
    }
  }

  return null;
}
